import { useState } from "react";
import useScrollReveal from "./shared/useScrollReveal";
import deliveryhub from "../../Assets/levdc/deliveryhub.png";
import fleetimg from "../../Assets/levdc/fleetdepot.png";
import publichub from "../../Assets/levdc/publichub.png";


const USE_CASES = [
  {
    img: deliveryhub,
    title: "Last Mile Delivery Hubs",
    body: "Keep delivery vehicles moving with convenient charging that helps minimise operational downtime between routes.",
  },
  {
    img: fleetimg,
    title: "Fleet Depots",
    body: "Support high-utilisation electric fleets with reliable charging infrastructure built around daily operations.",
  },
  {
    img: publichub,
    title: "Public Charging Hubs",
    body: "Enable accessible DC charging for compatible LEVs at high-traffic and strategically located charging destinations.",
  }, 
];

// NOTE: the original vanilla-JS version faded the image out/in (180ms)
// before swapping its src, for a smoother crossfade on hover. This React
// version swaps instantly via state, which is simpler and fine in
// practice — if you want the crossfade back, this section is the reason
// it's kept as its own component: only this file would need Framer
// Motion / a CSS transition tweak, nothing else on the page is affected.

export default function UseCases() {
  const ref = useScrollReveal();
  const [active, setActive] = useState(0);

  return (
    <section className="usecase2" id="usecases" ref={ref}>
      <div className="container ">
        <p className="section-label reveal" style={{ textAlign: "center" }}>Use Cases</p>
        <h2 className="section-title reveal" style={{ textAlign: "center" }}>Wherever You Move, We Keep You Charged.</h2>
        <p className="section-sub reveal" style={{ textAlign: "center", maxWidth: 640, marginLeft: "auto", marginRight: "auto" }}>
          Hover a category below to see how LEV DC fits into that world.
        </p>

        <div className="usecase2-visual reveal">
          <img src={USE_CASES[active].img} alt="LEV DC charging use case" />
        </div>

        <div className="usecase2-tabs reveal">
          {USE_CASES.map((uc, i) => (
            <div
              key={uc.title}
              className={`usecase2-tab ${i === active ? "active" : ""}`}
              onMouseEnter={() => setActive(i)}
              onClick={() => setActive(i)}
            >
              <h3>{uc.title}</h3>
              <p>{uc.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
